export default __webpack_public_path__ + "static/media/leg-left-side.6b3864e2.png";